import '@styles/app.scss';

import { initAccordions } from '@components-molecules/accordion';
import { initHolidayBanner } from '@molecules/holiday-banner';
import { initFooterFull } from '@organisms/footerFull';
import { deviceDetect } from '@tools/device-detect';
import { lazy } from '@tools/lazyloading';
import { initIntercom } from '@elements/intercom';
import { banner } from '@molecules/banner';
import { header } from '@organisms/header';
import { user } from '@organisms/user';
import { deobfuscate } from '@organisms/deobfuscate';
import { nav } from '@layout/nav';
import { profilePictureFallback } from '@tools/profile-picture-fallback';
import { userOnline } from '@organisms/user-online';

deviceDetect();
lazy();
profilePictureFallback();
banner();
user();
deobfuscate();
initAccordions();
initIntercom();
nav();
header();
initFooterFull();
initHolidayBanner();
userOnline();
